import { videoFactory, videoHydratedAction } from '@core/hydration';
import { getGlobalStore } from '@core/store';
const video = (callback) => {
    const partialVideo = videoFactory(callback);
    videoHydratedAction(getGlobalStore(), partialVideo);
};
export const hydrateApi = { video };
